import { PublishPlanStatusEnum } from './publish-plan-status-enum.generated';

const x: { [index: string]: string } = {};
x[PublishPlanStatusEnum.Unknown] = 'Unknown';
x[PublishPlanStatusEnum.BuildingSourceData] = 'Loading Data from Source Database';
x[PublishPlanStatusEnum.BuildingTargetData] = 'Loading Data from Target Database';
x[PublishPlanStatusEnum.BuildingCompareData] = 'Comparing Data';
x[PublishPlanStatusEnum.BuildingPublishPlan] = 'Building Publish Plan';
x[PublishPlanStatusEnum.Pending] = 'Pending';
x[PublishPlanStatusEnum.LoadingPublishTargetData] = 'Loading Publish Target Data';
x[PublishPlanStatusEnum.ApplyingPublishUpdates] = 'Applying Publish Updates';
x[PublishPlanStatusEnum.SavingPublishUpdates] = 'Saving Publish Updates';
x[PublishPlanStatusEnum.Published] = 'Publish Complete';
x[PublishPlanStatusEnum.LoadingTargetRollbackData] = 'Loading Target Rollback Data';
x[PublishPlanStatusEnum.ApplyingRollback] = 'Applying Rollback';
x[PublishPlanStatusEnum.SavingRollback] = 'Saving Rollback';
x[PublishPlanStatusEnum.Rolledback] = 'Rollback Complete';
x[PublishPlanStatusEnum.Aborted] = 'Aborted';
x[PublishPlanStatusEnum.BuildFailed] = 'Build Failed';
x[PublishPlanStatusEnum.PublishFailed] = 'Publish Failed';
x[PublishPlanStatusEnum.BeginningPublishPlanExecution] = 'Beginning Publish Plan Execution';
x[PublishPlanStatusEnum.BeginningPublishPlanRollbackExecution] = 'Beginning Publish Plan Rollback Execution';
x[PublishPlanStatusEnum.NoChanges] = 'No Changes';
x[PublishPlanStatusEnum.RollbackFailed] = 'Rollback Failed';
x[PublishPlanStatusEnum.BeginningPublishPlanCreation] = 'Beginning Publish Plan Creation';
export const PublishPlanStatusEnumDescriptions: { [indexer: string]: string } = x;
